import BaseApi from "./BaseApi";
import { ApiPaths } from './ApiPaths';

const create = () => {
    const api = BaseApi.create({errorCodes: [400, 403]});

    /**
     * Retrieves the summary queue data for this user
     */
    const getQueueSummary = (associateId) => api.get(ApiPaths.GET_QUEUE_SUMMARY(associateId));

    /**
     * Retrieves the summary of unassigned queue data
     */
    const getUnassignedQueueSummary = () => api.get(ApiPaths.UNASSIGNED_QUEUE_SUMMARY);

    /**
     * Retrieves the selected page of tickets with the specified sort options
     * @param {any} sort
     * @param {any} reversed
     * @param {any} limit
     * @param {any} offset
     */
    const getQueueTickets = (associateId, sort, reversed, limit, offset) => api.get(ApiPaths.GET_QUEUE(associateId, sort, reversed, limit, offset));

    /**
     * Retrieves the selected page of tickets with the specified sort options
     * @param { any } sort
     * @param { any } reversed
     * @param { any } limit
     * @param { any } offset
     */
    const getUnassignedQueueTickets = (sort, reversed, limit, offset) => api.get(ApiPaths.GET_UNASSIGNED_QUEUE(sort, reversed, limit, offset));

    /**
     * Retrieves the list of tickets for an associate Id and supports OData Filtering
     * @param { any } associateId
     */
    const getTicketsForAssociate = (associateId, query) => api.get(ApiPaths.GET_TICKET_SUMMARY(associateId, query));

    return {
        getQueueSummary,
        getUnassignedQueueSummary,
        getQueueTickets,
        getUnassignedQueueTickets,
        getTicketsForAssociate
    };
};

export default {
    create
}